import React, { useEffect, useState } from 'react';
import Heading from '../../common/Heading/Heading';
import {
  App,
  Space,
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Spin,
  Collapse,
  Descriptions,
  Flex,
  Divider,
  Checkbox,
  Radio,
  Dropdown,
} from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import {
  addMaterialRequest,
  cancelMaterialRequest,
  getItemDetails,
  getStockItems,
  submitMaterialRequest,
  updateMaterialRequest,
} from '../../../network/materialRequest';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getWarehouse } from '../../../network/warehouse';
import { useSelector } from 'react-redux';
import {
  MdDelete,
  MdModeEditOutline,
  MdOutlineReceiptLong,
  MdSubtitles,
} from 'react-icons/md';
import {
  CheckOutlined,
  CloseCircleOutlined,
  DownOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import dayjs from 'dayjs';
import {
  addPurchaseOrder,
  getMakePurchaseOrder,
  getOrderItemDetails,
  getPurchaseOrderDetails,
  getVATDetails,
  updatePurchaseOrder,
} from '../../../network/purchaseOrder';
import {
  getGetDetailsApi,
  getSearchApi,
  getSearchApiSearchText,
} from '../../../network/itemList';
import { getSupplier } from '../../../network/supplier';
import ItemOrderList from './ItemOrderList';
import TaxtList from './TaxtList';
import PaymentSchedule from './PaymentSchedule';
import { FaFileInvoiceDollar } from 'react-icons/fa6';
import { getSearchApiIsStock } from '../../../network/appointment';
import { CiShoppingBasket } from 'react-icons/ci';
import HeadingApp from '../../../hooks/HeadingApp';
const AddPurchaseOrder = ({ t, edit, order }) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [searchTextItems, setSearchTextItems] = useState('');
  const [loadingTaxesDetails, setLoadingTaxesDetails] = useState(false);
  const [selectName, setSelectName] = useState(null);
  const [dataStatus, setDataStatus] = useState(null);
  const [submitButton, setSubmitButton] = useState(false);
  const [searchtextSupplier, setSearchtextSupplier] = useState('');
  const [taxesDetails, setTaxesDetails] = useState([]);
  const [dataSourcePayment, setDataSourcePayment] = useState([
    {
      due_date: dayjs(),
      invoice_portion: 100,
    },
  ]);
  const [priceListSelect, setPriceListSelect] = useState();
  const { id, idOrder } = useParams();
  const [dataSource, setDataSource] = useState([
    {
      warehouse: form.getFieldValue('set_warehouse'),
    },
  ]);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const { companyName, currentLang } = useSelector((state) => state.user);
  const client = useQueryClient();
  const { message } = App.useApp();
  const [loadingAdd, setLoadingAdd] = useState(false);
  const { mutate: onAddPurchaseOrder } = useMutation({
    mutationKey: ['addPurchaseOrder'],
    mutationFn: (body) =>
      edit ? updatePurchaseOrder(body, id) : addPurchaseOrder(body),
    onSuccess: (data) => {
      setLoadingAdd(false);
      console.log(data?.message, 'datawwww');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      setSelectName(edit ? id : data?.data?.name);
      setSubmitButton(true);
      message.success(
        data?.message?.message ? data?.message?.message : 'Added successfully'
      );
      client.invalidateQueries({ queryKey: [queryKeys.getPurchaseOrder] });
      // form.resetFields();
      edit && dataStatus !== 0 && navigate('/purchase-order');
    },
    onError: (error) => {
      setLoadingAdd(false);
      // message.error(error.response.data._server_messages);
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
      console.log('error:', error);
    },
  });
  const {
    data: purchaseOrderDetails,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: [queryKeys.getPurchaseOrder, id],
    queryFn: () => getPurchaseOrderDetails(id),
    enabled: !!edit,
  });
  const { data: costCenters } = useQuery({
    queryKey: [queryKeys.getCostCentersSearch],
    queryFn: () => getSearchApi('Cost Center'),
    keepPreviousData: true,
  });
  const { data: makePurchaseOrder, isLoading: isLoadingMakePurchaseOrder } =
    useQuery({
      queryKey: [queryKeys.getMakePurchaseOrder, idOrder],
      queryFn: () => getMakePurchaseOrder(idOrder),
      enabled: !!order,
    });
  const { mutate: onGetTaxes, data: taxesList } = useMutation({
    mutationFn: (name) => getVATDetails('Purchase', name),
    onSuccess: (data) => {
      console.log(data, 'data');
      setLoadingTaxesDetails(false);
      setTaxesDetails(data?.message);
    },
    onError: (error) => {
      console.log(error, 'error');
    },
  });

  const handleSubmit = useMutation({
    mutationFn: (id) => submitMaterialRequest('Purchase Order', id),
    onSuccess: (data) => {
      console.log(data, 'data');
      setLoadingAdd(false);
      if (data?.message?.status === 500) {
        setLoadingAdd(false);
        message.error(data?.message?.message);
        return false;
      }
      submitButton && navigate('/purchase-order');
      message.success(data?.message?.message || 'Submitted successfully');
      client.invalidateQueries({ queryKey: [queryKeys.getPurchaseOrder] });
    },
    onError: () => {
      setLoadingAdd(false);
      message.error('Something went wrong');
    },
  });
  const handleCancle = useMutation({
    mutationFn: (id) => cancelMaterialRequest('Purchase Order', id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message?.message || 'Cancled successfully');
      client.invalidateQueries({ queryKey: [queryKeys.getPurchaseOrder] });
      navigate('/purchase-order');
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const netTotalWatch = Form.useWatch('total', form);
  const disableRoundedTotalWatch = Form.useWatch('disable_rounded_total', form);

  useEffect(() => {
    if (taxesList || dataSource) {
      const netTotal = form.getFieldValue('total');
      const disableRoundedTotal = form.getFieldValue('disable_rounded_total');
      const totalRate = taxesList?.message?.reduce(
        (sum, item) => sum + item?.rate,
        0
      );
      const taxAmount = (netTotal * totalRate) / 100;
      const grandTotal = netTotal + taxAmount;
      const roundedTotal = disableRoundedTotal
        ? Math.round(grandTotal)
        : grandTotal;
      const roundingAdjustment = (roundedTotal - grandTotal).toFixed(2);
      setDataSourcePayment(
        dataSourcePayment?.map((item) => ({
          ...item,
          // invoice_portion: 100,
          payment_amount: roundedTotal,
          invoice_portion: item.invoice_portion || 100,
        }))
      );
      form.setFieldsValue({
        grand_total: grandTotal,
        total_taxes_and_charges: taxAmount,
        rounded_total: roundedTotal,
        rounding_adjustment: roundingAdjustment,
      });
    }
  }, [taxesList, form, dataSource, netTotalWatch, disableRoundedTotalWatch]);

  const { data: warehouse } = useQuery({
    queryKey: [queryKeys.getWarehouse],
    queryFn: () =>
      getWarehouse({
        key: '',
        value: '',
      }),
    keepPreviousData: true,
  });
  const { data: itemsList } = useQuery({
    queryKey: [queryKeys.getSearchApiIsStock, searchTextItems],
    queryFn: () =>
      getSearchApiIsStock({ type: 'Item', text: searchTextItems, stock: 1 }),
    keepPreviousData: true,
    enabled: searchTextItems?.length >= 3 || searchTextItems?.length === 0,
  });
  // const { data: itemsList } = useQuery({
  //   queryKey: [queryKeys.getStockItems],
  //   queryFn: () => getStockItems(),
  //   keepPreviousData: true,
  // });
  const { mutate: handleGetDetails } = useMutation({
    mutationKey: [queryKeys.getSearchApiAccountList],
    mutationFn: (values) =>
      getGetDetailsApi({
        type: 'Supplier',
        name: values,
        // fields: ['supplier_name', 'supplier_name_in_arabic'],
        fields: ['supplier_name'],
      }),
    onSuccess: (data) => {
      form.setFieldsValue({
        supplier_name: data?.message?.supplier_name,
        // supplier_name_in_arabic: data?.message?.supplier_name_in_arabic,
      });
    },
  });
  const { data: Supplier } = useQuery({
    queryKey: [queryKeys.getSearchApiAccountList, searchtextSupplier],
    queryFn: () =>
      getSearchApiSearchText({
        type: 'Supplier',
        searchTxt: searchtextSupplier,
      }),
    keepPreviousData: true,

    enabled:
      searchtextSupplier?.length >= 3 || searchtextSupplier?.length === 0,
  });
  const { data: priceList } = useQuery({
    queryKey: [queryKeys.getPriceListSearch],
    queryFn: () => getSearchApi('Price List'),
    keepPreviousData: true,
  });
  const { data: taxesCharges } = useQuery({
    queryKey: [queryKeys.getItemTaxTemplate],
    queryFn: () => getSearchApi('Purchase Taxes and Charges Template'),
    keepPreviousData: true,
  });
  const { data: suppliers } = useQuery({
    queryKey: [queryKeys.getSupplier],
    queryFn: () =>
      getSupplier({
        key: '',
        value: '',
      }),
    keepPreviousData: true,
  });
  useEffect(() => {
    if (edit) {
      refetch();
    }
  }, [edit, refetch]);

  useEffect(() => {
    if (edit && purchaseOrderDetails) {
      setDataStatus(purchaseOrderDetails?.data?.docstatus);
      setTaxesDetails(purchaseOrderDetails?.data?.taxes);
      onGetTaxes(purchaseOrderDetails?.data?.taxes_and_charges);
      setDataSourcePayment(
        purchaseOrderDetails?.data?.payment_schedule?.length
          ? purchaseOrderDetails?.data?.payment_schedule?.map((payment) => ({
              ...payment,
              due_date: dayjs(payment?.due_date),
              invoice_portion: Number(payment?.invoice_portion || 100),
            }))
          : [{}]
      );
      setDataSource(
        purchaseOrderDetails?.data?.items?.map((item) => ({
          ...item,
          schedule_date: dayjs(item?.schedule_date),
        })) || [{}]
      );
      form.setFieldsValue({
        ...purchaseOrderDetails?.data,
        base_rounded_total: Number(
          purchaseOrderDetails?.data?.base_rounded_total
        ),
        grand_total: Number(purchaseOrderDetails?.data?.grand_total),
        rounding_adjustment: Number(
          purchaseOrderDetails?.data?.rounding_adjustment
        ),
        rounded_total: Number(purchaseOrderDetails?.data?.rounded_total),
        disable_rounded_total: Number(
          purchaseOrderDetails?.data?.disable_rounded_total
        ),
        base_discount_amount: Number(
          purchaseOrderDetails?.data?.base_discount_amount
        ),
        additional_discount_percentage: Number(
          purchaseOrderDetails?.data?.additional_discount_percentage
        ),
        ignore_pricing_rule: purchaseOrderDetails?.data.ignore_pricing_rule
          ? 1
          : 0,
        transaction_date: dayjs(purchaseOrderDetails?.data?.transaction_date),
        schedule_date: dayjs(purchaseOrderDetails?.data?.schedule_date),
        // payment_schedule: dataSourcePayment?.map((payment) => ({ ...payment, due_date:dayjs(payment?.due_date).format('YYYY-MM-DD')})),
        // payment_schedule: purchaseOrderDetails?.data?.payment_schedule?.map((payment) => ({ ...payment, due_date:dayjs(payment?.due_date)})) || [{}],
      });
    } else {
      form.resetFields();
    }
  }, [edit, purchaseOrderDetails, form]);
  useEffect(() => {
    if (order && makePurchaseOrder) {
      setTaxesDetails(makePurchaseOrder?.message?.taxes);
      // onGetTaxes(makePurchaseOrder?.message?.taxes_and_charges);
      setDataSourcePayment(
        makePurchaseOrder?.message?.payment_schedule?.length
          ? makePurchaseOrder?.message?.payment_schedule?.map((payment) => ({
              ...payment,
              due_date: dayjs(payment?.due_date),
              invoice_portion: payment?.invoice_portion || 100,
            }))
          : [{}]
      );
      setDataSource(
        makePurchaseOrder?.message?.items?.map((item) => ({
          ...item,
          schedule_date: dayjs(item?.schedule_date),
        })) || [{}]
      );
      form.setFieldsValue({
        ...makePurchaseOrder?.message,
        supplier: '',
        base_rounded_total: Number(
          makePurchaseOrder?.message?.base_rounded_total
        ),
        grand_total: Number(makePurchaseOrder?.message?.grand_total),
        rounding_adjustment: Number(
          makePurchaseOrder?.message?.rounding_adjustment
        ),
        rounded_total: Number(makePurchaseOrder?.message?.rounded_total),
        disable_rounded_total: Number(
          makePurchaseOrder?.message?.disable_rounded_total
        ),
        base_discount_amount: Number(
          makePurchaseOrder?.message?.base_discount_amount
        ),
        additional_discount_percentage: Number(
          makePurchaseOrder?.message?.additional_discount_percentage
        ),
        ignore_pricing_rule: makePurchaseOrder?.message.ignore_pricing_rule
          ? 1
          : 0,
        transaction_date: dayjs(makePurchaseOrder?.message?.transaction_date),
        schedule_date: dayjs(makePurchaseOrder?.message?.schedule_date),
        payment_schedule: makePurchaseOrder?.message?.length
          ? makePurchaseOrder?.message?.map((payment) => ({
              ...payment,
              due_date: dayjs(payment?.due_date),
            }))
          : [{}],
        // payment_schedule: makePurchaseOrder?.message?.payment_schedule.length ? makePurchaseOrder?.message?.payment_schedule?.map((payment) => ({ ...payment, due_date:dayjs(payment?.due_date)})) : [{}],
      });
    } else {
      form.resetFields();
    }
  }, [order, makePurchaseOrder, form]);
  const onFinish = (values) => {
    const totalPortion = dataSourcePayment?.reduce(
      (acc, curr) => acc + Number(curr?.invoice_portion),
      0
    );
    if (totalPortion !== 100) {
      return message.error('Total portion should be 100%');
    }
    setLoadingAdd(true);
    onAddPurchaseOrder({
      ...values,
      company: companyName,
      conversion_rate: 1,
      disable_rounded_total: values?.disable_rounded_total ? 1 : 0,
      plc_conversion_rate: 1,
      base_rounded_total: 0,
      base_discount_amount: Number(values?.base_discount_amount),
      additional_discount_percentage: Number(
        values?.additional_discount_percentage
      ),
      total_taxes_and_charges: Number(values?.total_taxes_and_charges),
      grand_total: Number(values?.grand_total),
      rounding_adjustment: Number(values?.rounding_adjustment),
      rounded_total: Number(values?.rounded_total),
      disable_rounded_total: Number(values?.disable_rounded_total),
      ignore_pricing_rule: values.ignore_pricing_rule ? 1 : 0,
      transaction_date: dayjs(values?.transaction_date).format('YYYY-MM-DD'),
      schedule_date: dayjs(values?.schedule_date).format('YYYY-MM-DD'),
      items: dataSource?.map((item) => ({
        ...item,
        schedule_date: dayjs(item?.schedule_date).format('YYYY-MM-DD'),
      })),
      taxes: taxesList?.message?.map((tax) => ({ ...tax })),
      payment_schedule: dataSourcePayment?.map((payment) => ({
        invoice_portion: Number(payment?.invoice_portion),
        due_date: dayjs(payment?.due_date).format('YYYY-MM-DD'),
        discount: Number(payment?.discount),
        payment_amount: Number(payment?.payment_amount),
        outstanding: Number(payment?.outstanding),
        paid_amount: Number(payment?.paid_amount),
        discounted_amount: Number(payment?.discounted_amount),
        base_payment_amount: Number(payment?.base_payment_amount),
        description: payment?.description,
      })),
    });
  };

  const disountApplyType = Form.useWatch('discount_type', form);

  if (isLoading || isLoadingMakePurchaseOrder) {
    return (
      <div
        style={{
          width: '100%',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }
  // const itemsMenu = [
  //   {
  //     key: '1',
  //     label: (
  //       <Button
  //         size="small"
  //         type="text"
  //         style={{ width: '100%' }}
  //         icon={<MdSubtitles />}
  //         disabled={
  //           purchaseOrderDetails?.data?.status === 'Draft' ? false : true
  //         }
  //       >
  //         {t.submit}
  //       </Button>
  //     ),
  //     onClick: () => {
  //       handleSubmit.mutate(purchaseOrderDetails?.data?.name);
  //     },
  //   },
  //   {
  //     key: '2',
  //     label: (
  //       <Button
  //         size="small"
  //         type="text"
  //         icon={<FaFileInvoiceDollar />}
  //         disabled={
  //           purchaseOrderDetails?.data?.status === 'To Bill'
  //             ? false
  //             : purchaseOrderDetails?.data?.status === 'To Receive and Bill'
  //             ? false
  //             : true
  //         }
  //       >
  //         {t.AddInvoice}
  //       </Button>
  //     ),
  //     onClick: () => {
  //       navigate(
  //         `/purchase-order/add-invoice/${purchaseOrderDetails?.data?.name}`
  //       );
  //     },
  //   },
  //   {
  //     key: '3',
  //     label: (
  //       <Button
  //         size="small"
  //         type="text"
  //         icon={<MdOutlineReceiptLong />}
  //         disabled={
  //           purchaseOrderDetails?.data?.status === 'To Receive'
  //             ? false
  //             : purchaseOrderDetails?.data?.status === 'To Receive and Bill'
  //             ? false
  //             : true
  //         }
  //       >
  //         {t.AddReceipt}
  //       </Button>
  //     ),
  //     onClick: () => {
  //       navigate(
  //         `/purchase-order/add-receipt/${purchaseOrderDetails?.data?.name}`
  //       );
  //     },
  //   },
  // ];
  const items = (record) => [
    {
      key: '3',
      label: t.AddInvoice,
      icon: <FaFileInvoiceDollar />,
      disabled:
        record?.status === 'To Bill'
          ? false
          : record?.status === 'To Receive and Bill'
          ? false
          : true,
      onClick: () => {
        navigate(`/purchase-order/add-invoice/${record?.name}`);
      },
    },
    {
      key: '4',
      label: t.AddReceipt,
      disabled: record?.status === 'To Receive' ? false : true,
      icon: <MdOutlineReceiptLong />,
      onClick: () => navigate(`/purchase-order/add-receipt/${record?.name}`),
    },
    {
      type: 'divider',
    },
    {
      key: '6',
      label: t.submit,
      icon: <CheckOutlined />,
      disabled: record?.status === 'Draft' ? false : true,
      onClick: () => handleSubmit.mutate(record?.name),
    },
    {
      key: '7',
      label: t.Cancel,
      icon: <CloseCircleOutlined />,
      disabled: record?.docstatus === 1 ? false : true,
      onClick: () => handleCancle.mutate(record?.name),
    },
  ];
  return (
    <>
      {/* <Heading
        title={t.Inventory}
        subTitle={edit ? t.editPurchaseOrder : t.addPurchaseOrder}
        path="/purchase-order"
      /> */}
      <HeadingApp
        nameTab={t.Inventory}
        title={t.purchaseOrder}
        subTitle={edit ? t.editPurchaseOrder : t.addPurchaseOrder}
        icon={<CiShoppingBasket />}
      />
      <Card style={{ borderRadius: '0px' }}>
        <Flex justify="end" align="center">
          {edit && (
            <Dropdown
              menu={{ items: items(purchaseOrderDetails?.data) }}
              trigger={['click']}
              arrow
              // onClick={() => setStatus(record)}
            >
              <Button size="small" type="text" className="btn-light">
                {t.action}
                <DownOutlined />
              </Button>
            </Dropdown>
          )}
        </Flex>
        <Form
          form={form}
          name="add-purchase-order"
          layout="vertical"
          onFinish={onFinish}
          initialValues={{
            taxes: [{}],
            payment_schedule: [{}],
            items: [{}],
          }}
          style={{
            marginTop: '20px',
          }}
        >
          <Row gutter={[16, 0]}>
            <Col xs={24} md={24} lg={18}>
              <Row gutter={[16, 0]}>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="supplier"
                    label={t.Supplier}
                    rules={[{ required: true }]}
                  >
                    {/* <Select
                  placeholder={t.Supplier}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? '').toLocaleLowerCase().includes(input)
                  }
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? '')
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? '').toLowerCase())
                  }
                  onChange={(value, option) => {
                    form.setFieldsValue({
                      supplier_name: option?.option?.supplier_name,
                      supplier_name_in_arabic:
                        option?.option?.supplier_name_in_arabic,
                    });
                  }}
                  options={suppliers?.data?.map((item) => ({
                    value:
                      item?.[
                        currentLang === 'en'
                          ? 'supplier_name'
                          : 'supplier_name_in_arabic'
                      ],
                    label: item?.name,
                    option: item,
                  }))}
                /> */}
                    <Select
                      placeholder={t.Supplier}
                      style={{ width: '100%' }}
                      showSearch
                      filterOption={false}
                      popupMatchSelectWidth={false}
                      // options={customer?.message?.map((item) => ({
                      //   value: item?.value,
                      //   label: item?.value,
                      // }))}
                      onChange={(value) => {
                        handleGetDetails(value);
                      }}
                      onSearch={(value) => setSearchtextSupplier(value)}
                    >
                      {Supplier?.message?.map((item) => (
                        <Select.Option key={item?.value}>
                          <Flex gap={1} vertical>
                            <span>{item?.value}</span>
                            <span
                              className="item-description"
                              style={{ fontSize: '11px', color: 'gray' }}
                            >
                              {item?.description}
                            </span>
                          </Flex>
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="transaction_date"
                    label={t.transactionDate}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                    initialValue={dayjs()}
                  >
                    <DatePicker
                      style={{ width: '100%' }}
                      placeholder={t.transactionDate}
                      format="YYYY-MM-DD"
                      disabledDate={(current) =>
                        current.endOf('d').valueOf() <
                        dayjs().endOf('d').valueOf()
                      }
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="schedule_date"
                    label={t.scheduleDate}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                    initialValue={dayjs()}
                  >
                    <DatePicker
                      style={{ width: '100%' }}
                      placeholder={t.scheduleDate}
                      format="YYYY-MM-DD"
                    />
                  </Form.Item>
                </Col>
                {/* <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="supplier_name_in_arabic"
                    label={t.SupplierNameInArabic}
                    // rules={[{ required: true }]}
                  >
                    <Input placeholder={t.SupplierNameInArabic} disabled />
                  </Form.Item>
                </Col> */}
                {/* <Divider orientation="left" >
              {t.accountingDimensions}
            </Divider> */}
                <Divider orientation="left">{t.currencyAndPriceList}</Divider>
                {/* <Col xs={12} md={8} xl={8} xxl={8}>
              <Form.Item
                name="currency"
                label={t.currency}
                rules={[
                  {
                    required: true,
                  },
                ]}
                initialValue={'SAR'}
              >
                <Input placeholder={t.currency} disabled />
              </Form.Item>
            </Col> */}
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="buying_price_list"
                    label={t.buyingPriceList}
                    // rules={[{ required: true }]}
                  >
                    <Select
                      placeholder={t.buyingPriceList}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? '')
                          .toLocaleLowerCase()
                          .includes(input)
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? '')
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? '').toLowerCase())
                      }
                      onChange={(value, option) => {
                        setPriceListSelect(value);
                        form.setFieldsValue({
                          price_list_currency: option?.option?.description,
                        });
                      }}
                      options={priceList?.message?.map((item) => ({
                        value: item?.value,
                        label: item?.value,
                        option: item,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="cost_center"
                    label={t.costCenter}
                    style={{ width: '100%', marginBottom: '0px' }}
                  >
                    <Select
                      placeholder={t.costCenter}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? '')
                          .toLocaleLowerCase()
                          .includes(input)
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? '')
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? '').toLowerCase())
                      }
                      options={costCenters?.message?.map((item) => ({
                        value: item?.value,
                        label: item?.value,
                      }))}
                    />
                  </Form.Item>
                </Col>
                {/* <Col xs={12} md={8} xl={8} xxl={8}>
              <Form.Item
                name="price_list_currency"
                label={t.priceListCurrency}
                rules={[{ required: true }]}
              >
                <Input placeholder={t.priceListCurrency} disabled />
              </Form.Item>
            </Col> */}
                {/* <Col xs={12} md={8} xl={8} xxl={8}>
              <Form.Item
                name="ignore_pricing_rule"
                label={t.ignorePricingRule}
                valuePropName="checked"
                // layout="horizontal"
              >
                <Checkbox />
              </Form.Item>
            </Col> */}
                {/* <Divider />
            <Col xs={24} md={12} xl={8} xxl={8} >
              <Form.Item
                name="conversion_rate"
                label={t.conversionRate}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
              <Input placeholder={t.conversionRate} type='number'  min={0} />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} xl={8} xxl={8} >
              <Form.Item
                name="plc_conversion_rate"
                label={t.plcConversionRate}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
              <Input placeholder={t.plcConversionRate} type='number' min={0} />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} xl={8} xxl={8}>
              <Form.Item
                name="base_rounded_total"
                label={t.baseRoundedTotal}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
              <Input 
                placeholder={t.baseRoundedTotal}
                type="number"
                min={0}
              />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} xl={8} xxl={8}>
              <Form.Item
                name="base_discount_amount"
                label={t.baseDiscountAmount}
              >
              <Input 
                placeholder={t.baseDiscountAmount}
                type="number"
                 step="0.01"
              />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} xl={8} xxl={8}>
              <Form.Item
                name="additional_discount_percentage"
                label={t.additionalDiscountPercentage}
              >
              <Input 
                placeholder={t.additionalDiscountPercentage}
                type="number"
                min={0}
              />
              </Form.Item>
            </Col> */}
                <Col
                  xs={24}
                  md={12}
                  xl={8}
                  xxl={8}
                  style={{
                    display: 'flex',
                    justifyContent: 'start',
                    alignItems: 'center',
                  }}
                >
                  {/* <Form.Item
                name="disable_rounded_total"
                label={t.disableRoundedTotal}
                initialValue={0}
                className="custom_plus_riyal"
              >
                <Radio.Group>
                  <Radio value={1}>{t.Yes}</Radio>
                  <Radio value={0}>{t.No}</Radio>
                </Radio.Group>
              </Form.Item> */}
                  <Form.Item
                    name="disable_rounded_total"
                    label={t.disableRoundedTotal}
                    valuePropName="checked"
                    layout="horizontal"
                    className="margin-bottom-0"
                  >
                    <Checkbox />
                  </Form.Item>
                </Col>
                <Divider orientation="left">{t.items}</Divider>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="set_warehouse"
                    label={t.setWarehouse}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                  >
                    <Select
                      placeholder={t.setWarehouse}
                      style={{ width: '100%' }}
                      popupMatchSelectWidth={false}
                      onChange={(value) => {
                        setDataSource(
                          dataSource.map((item) => {
                            return {
                              ...item,
                              warehouse: value,
                            };
                          })
                        );
                      }}
                      options={warehouse?.data?.map((item) => ({
                        value: item?.name,
                        label: item?.warehouse_name,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col span={24} style={{ marginBottom: '20px' }}>
                  <ItemOrderList
                    type="Purchase Order"
                    keyData="Purchase Order"
                    priceList={priceListSelect}
                    setSelectedIndex={setSelectedIndex}
                    selectedIndex={selectedIndex}
                    dataSource={dataSource}
                    setDataSource={setDataSource}
                    form={form}
                    itemsList={itemsList}
                    setSearchTextItems={setSearchTextItems}
                    warehouse={warehouse}
                    t={t}
                  />
                </Col>

                <Divider orientation="left">{t.TaxesandCharges}</Divider>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="taxes_and_charges"
                    label={t.TaxesandCharges}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Select
                      placeholder={t.TaxesandCharges}
                      style={{ width: '100%' }}
                      popupMatchSelectWidth={false}
                      onChange={(value) => {
                        setLoadingTaxesDetails(true);
                        onGetTaxes(value);
                      }}
                      options={taxesCharges?.message?.map((item) => ({
                        value: item?.value,
                        label: item?.value,
                      }))}
                    />
                  </Form.Item>
                </Col>

                <Col span={24}>
                  <TaxtList
                    t={t}
                    form={form}
                    data={taxesDetails}
                    loadingTaxesDetails={loadingTaxesDetails}
                  />
                </Col>
                <Divider orientation="left">{t.paymentSchedule}</Divider>
                <Col span={24}>
                  <PaymentSchedule
                    dataSourcePayment={dataSourcePayment}
                    setDataSourcePayment={setDataSourcePayment}
                    t={t}
                    form={form}
                    type="Order"
                  />
                </Col>
                <Divider />

                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="total"
                    label={t.Total}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                  >
                    <Input
                      placeholder={t.Total}
                      type="number"
                      min={0}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="total_qty"
                    label={t.totalQty}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                  >
                    <Input
                      placeholder={t.totalQty}
                      type="number"
                      min={0}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="total_taxes_and_charges"
                    label={t.TotalTaxesandCharges}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                  >
                    <Input
                      placeholder={t.TotalTaxesandCharges}
                      type="number"
                      min={0}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="grand_total"
                    label={t.grandTotal}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                  >
                    <Input
                      placeholder={t.grandTotal}
                      type="number"
                      min={0}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="rounding_adjustment"
                    label={t.roundingAdjustment}
                  >
                    <Input
                      placeholder={t.roundingAdjustment}
                      type="number"
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="rounded_total"
                    label={t.roundedTotal}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                    disabled
                  >
                    <Input
                      placeholder={t.roundedTotal}
                      type="number"
                      min={0}
                      disabled
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="apply_discount_on"
                    label={t.applyDiscountOn}
                    // rules={[
                    //   {
                    //       required: true,
                    //     },
                    // ]}
                  >
                    <Select
                      placeholder={t.applyDiscountOn}
                      options={[
                        {
                          value: 'Grand Total',
                          label: t.GrandTotal,
                        },
                        {
                          value: 'Net Total',
                          label: t.netTotal,
                        },
                      ]}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="discount_type"
                    label={t.discountType}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                  >
                    <Select
                      placeholder={t.discountType}
                      style={{ width: '100%' }}
                      options={[
                        {
                          value: 'Percentage',
                          label: t.percentage,
                        },
                        {
                          value: 'Amount',
                          label: t.amount,
                        },
                      ]}
                    />
                  </Form.Item>
                </Col>
                {disountApplyType === 'Amount' && (
                  <Col xs={24} md={12} xl={8} xxl={8}>
                    <Form.Item name="base_discount_amount" label={t.value}>
                      <Input
                        placeholder={t.value}
                        type="number"
                        // disabled
                      />
                    </Form.Item>
                  </Col>
                )}
                {disountApplyType === 'Percentage' && (
                  <Col xs={24} md={12} xl={8} xxl={8}>
                    <Form.Item
                      name="additional_discount_percentage"
                      label={t.value}
                    >
                      <Input
                        placeholder={t.value}
                        type="number"
                        // disabled
                      />
                    </Form.Item>
                  </Col>
                )}
              </Row>
              <div className="form-btns">
                <Button
                  type="primary"
                  ghost
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  {t.Cancel}
                </Button>
                <Button
                  type="primary"
                  onClick={() => {
                    if (submitButton) {
                      setLoadingAdd(true);
                      handleSubmit.mutate(selectName);
                    } else {
                      form.submit();
                    }
                  }}
                  loading={loadingAdd}
                >
                  {/* {edit ? t.edit : t.submit} */}
                  {submitButton ? t.submit : edit ? t.edit : t.Save}
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Card>
    </>
  );
};

export default AddPurchaseOrder;
